import { type AppMode } from '@databases/modes';

import { type ModeConfig } from '../modes/default-mode-config';
import { createDefaultModeConfig } from '../modes/default-mode-config';
import { createEmbedModeConfig } from '../modes/embed-mode-config';
import { createMobileModeConfig } from '../modes/mobile-mode-config';
import { createNativeEmbedModeConfig } from '../modes/native-embed-mode-config';

export { type ModeConfig } from '../modes/default-mode-config';

export function getModeConfig(mode: AppMode): ModeConfig {
  const modeConfigs: Record<typeof mode, () => ModeConfig> = {
    EMBED: createEmbedModeConfig,
    MOBILE: createMobileModeConfig,
    NATIVE_EMBED: createNativeEmbedModeConfig,
    STANDALONE: createDefaultModeConfig,
  };

  const config = modeConfigs[mode];

  return config();
}
